import { graphql, useFragment } from 'react-relay/hooks';
import { useAppState } from '../appState';
import { useAccountDataFragment$key } from './__generated__/useAccountDataFragment.graphql';

const accountDataFragment = graphql`
    fragment useAccountDataFragment on Query {
        ecommerceSettings {
            ecommerceName
            ecommerceID
        }
        overviewSubscription {
            sellerAppsumoMarketPlaceID
        }
        user {
            userID
            email
            name
        }
        sellerStaticsDetails {
            userID
            state
            subState
            username
            registeredOn
            subscribedOn
            configuredOn
            planName
            orders
            ordersAsPaying
            quantity
            amount
            interactions
            products
            designs
            printfulProducts
            printfulOrders
            lastDayOrders
            lastOrderDate
            totalFees
            previousDayItemsOrdered
            countryID
            userSource
            privacy
            isExtraViews
            identityProviderId
            integrationState
        }
    }
`;

export const useAccountData = () => {
    const { queryData } = useAppState();
    const data = useFragment<useAccountDataFragment$key>(accountDataFragment, queryData!);

    const userInfo = data.user;
    const ecommerceSettings = data.ecommerceSettings;

    const sellerStaticsDetail = data.sellerStaticsDetails;
    const appsumoMarketPlaceID = data.overviewSubscription?.sellerAppsumoMarketPlaceID ?? 0;

    return { data: data, userInfo, ecommerceSettings, sellerStaticsDetail, appsumoMarketPlaceID };
};
